import { isTargetTextInput } from "@/utils/clipboardUtils";
import { ShortcutConfig, ShortcutMap } from "./types";

export const shortcutMapToArray = (map: ShortcutMap): ShortcutConfig[] => {
  return Object.entries(map).map(([key, config]) => ({
    key,
    handler: config.handler as unknown as (e: KeyboardEvent) => void,
    description: config.description,
    preventDefault: config.preventDefault ?? true,
  }));
};

export const shouldIgnoreEvent = (e: KeyboardEvent): boolean => {
  return isTargetTextInput(e.target as HTMLElement);
};
